/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '../styles/main.scss';
import '../styles/wallet-adapter.scss';
import { createVuetify } from 'vuetify';
import { mdi, aliases as mdiAliases } from 'vuetify/iconsets/mdi';
import { fa, aliases as faAliases } from 'vuetify/iconsets/fa';
import { VNumberInput } from 'vuetify/labs/VNumberInput';

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components: {
    VNumberInput,
  },
  defaults: {
    VBtn: {
      flat: true,
      variant: 'tonal',
      style: 'text-transform: none;',
    },
    VCard: {
      flat: true,
      border: true,
    },
    VTextField: {
      flat: true,
    },
    global: {
      ripple: false,
    },
  },
  theme: {
    defaultTheme: 'dark',
    themes: {
      light: {
        colors: {
          primary: '#C7F284',
        },
      },
      dark: {
        colors: {
          primary: '#C7F284',
          background: '#051724',
          surface: '#131C25',
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...faAliases,
      ...mdiAliases,
    },
    sets: { mdi, fa },
  },
});
